import { ICancellable } from '@infrastructure/axios';
import { User, UserSettingPreferences } from '../../types';
import { IGetGeneralSettings } from '@core/domain/Settings/interfaces';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';
import { IUserSessionRespository } from '@infrastructure/persistance/user-session';
import GetGeneralSettings from '@core/domain/Settings/use-cases/GetGeneralSettings';

export interface IGetUserProfileUseCase extends ICancellable {
  execute(): Promise<User & UserSettingPreferences>;
}

export default class GetUserProfileUseCase extends HttpGetRequest<User> implements IGetUserProfileUseCase {
  private userSettingsService: IGetGeneralSettings;
  constructor(private sessionReporsitory: IUserSessionRespository) {
    super();
    this.userSettingsService = new GetGeneralSettings();
  }

  public async execute(): Promise<User & UserSettingPreferences> {
    const res = await this.dispatch(`/profile`);
    const user = res.data.data;
    await this.sessionReporsitory.saveProfile(user);

    const settingsPreferences = await this.userSettingsService.execute();
    await this.sessionReporsitory.setSettingPreferences(settingsPreferences);

    return { ...user, settings: settingsPreferences };
  }
}
